const LOCATION_KEY = 'authenticulture_location';

export interface LocationData {
  city: string;
  country: string;
  region: string;
  source: 'ip' | 'manual';
  overridden: boolean;
}

function normalizeCity(city: string): string {
  return city.trim().replace(/\b\w/g, c => c.toUpperCase());
}

export function getCity(): LocationData | null {
  const stored = localStorage.getItem(LOCATION_KEY);
  return stored ? JSON.parse(stored) : null;
}

export function setCity(city: string, country = '', region = ''): void {
  const data: LocationData = {
    city: normalizeCity(city),
    country,
    region,
    source: 'manual',
    overridden: true,
  };
  localStorage.setItem(LOCATION_KEY, JSON.stringify(data));
}

export function clearCity(): void {
  localStorage.removeItem(LOCATION_KEY);
}

export async function detectCity(): Promise<LocationData | null> {
  const existing = getCity();
  if (existing) return existing;

  try {
    const res = await fetch('https://ip-api.com/json/?fields=city,country,regionName');
    if (!res.ok) return null;
    const data = await res.json();
    if (!data.city) return null;

    const location: LocationData = {
      city: normalizeCity(data.city),
      country: data.country || '',
      region: data.regionName || '',
      source: 'ip',
      overridden: false,
    };

    localStorage.setItem(LOCATION_KEY, JSON.stringify(location));
    return location;
  } catch {
    return null;
  }
}
